import React, { useState, useEffect } from 'react';
import apiFetch from '../../../../utils/api';
import Preloader from '../../../../components/Preloader/Preloader';
import Pagination from '../../../../components/Pagination/Pagination';
import './WithdrawHistory.css';

const WithdrawHistory = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const fetchData = () => {
    setLoading(true);
    apiFetch(`/api/withdrawals?page=${page}`)
      .then(res => res.json())
      .then(res => { 
        setData(res.withdrawals || []); 
        setTotalPages(res.totalPages || 1);
        setLoading(false); 
      })
      .catch(() => setLoading(false));
  };

  useEffect(fetchData, [page]);

  return (
    <div className="wh-wrapper">
      <div className="wh-breadcrumb-nav">
        <span className="wh-icon-home">🏠</span> / Withdrawal History
      </div>

      <div className="wh-page-header">
        <h2 className="wh-page-heading">Withdrawal History</h2>
      </div>

      <div className="wh-data-card">
        <div className="wh-data-header">Withdrawals List</div>
        <div className="wh-table-container">
          {loading ? (
            <Preloader message="Fetching withdrawal history..." fullScreen={false} />
          ) : data.length === 0 ? (
            <p style={{ padding: '2rem', textAlign: 'center', color: 'var(--awp-text-subtle)' }}>No withdrawals yet.</p>
          ) : (
            <>
              <table className="wh-custom-table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Amount</th>
                    <th>Description</th>
                    <th>Method</th>
                    <th>Account</th>
                    <th>Status</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((row) => (
                    <tr key={row.id}>
                      <td>{row.id}</td>
                      <td>Rs. {row.amount}</td>
                      <td style={{ color: 'var(--awp-accent)', fontWeight: '500' }}>Ads watch earning</td>
                      <td>{row.paymentMethod || '—'}</td>
                      <td>{row.accountNumber || row.email || '—'}</td>
                      <td>
                        <span className={`wh-badge wh-badge--${row.status.toLowerCase()}`}>{row.status}</span>
                      </td>
                      <td>{row.updatedAt}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <Pagination 
                currentPage={page} 
                totalPages={totalPages} 
                onPageChange={setPage} 
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default WithdrawHistory;